import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import HistoricGraphs from './HistoricGraphs';
import { useState, useMemo } from 'react';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';

export default function HistoricTabs() {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');

  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Total Supply' },
      { key: 'supply_apy', value: 'Supply APY' }
    ],
    []
  );

  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [data, error] = useApi({
    url: `/spark/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (error) {
    throw error;
  }
  let content;
  if (data) {
    content = (
      <HistoricGraphs
        data={data}
        timeFilter={timeFilter}
        activeDisplayOption={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    );
  } else {
    content = <ChartSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap="xs">
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeDisplayOption}
        onChange={setActiveDisplayOption}
      />
      {content}
    </Flex>
  );
}
